import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=07874efa&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=07874efa&prod&scoped=true&lang=less"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=07874efa&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07874efa",
  null
  
)

export default component.exports